export default __webpack_public_path__ + "static/media/light-mode.faa5054f.svg";